"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCreateNewsletterSubscription = void 0;
var NewsletterSubscribeEvent = _interopRequireWildcard(require("@ori-events/newsletter-subscribe"));
var _globalApiClientReact = require("@ori/global-api-client-react");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _react = require("react");
var _NewsletterDialogContext = require("../components/Subscribe/components/NewsletterDialog/components/NewsletterDialogContext");
var _types = require("../components/Subscribe/components/NewsletterDialog/types");
var _constants = require("../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/* istanbul ignore file -- api */

const SUCCESS_STATUSES = new Set(['New', 'Subscribed', 'Pending']);
const useCreateNewsletterSubscription = () => {
  const globalApiClient = (0, _globalApiClientReact.useApiClient)();
  const {
    setStatus
  } = (0, _NewsletterDialogContext.useNewsletterDialogContext)();
  const createSubscription = (0, _react.useCallback)(async ({
    origin,
    email
  }) => {
    globalThis.dispatchEvent(new CustomEvent(NewsletterSubscribeEvent.Name));
    const result = await (0, _globalApiClientReact.createNewsletterSubscription)(globalApiClient, {
      email,
      source: window.location.pathname,
      origin
    });
    if (result.status === 200 && SUCCESS_STATUSES.has(result.data.status)) {
      _jsCookie.default.set(_constants.newsletterSubscribeCookieKey, _constants.newsletterSubscribeCookieValue);
      setStatus(_types.SubscriptionProcessStatus.Subscribed);
    } else {
      setStatus(_types.SubscriptionProcessStatus.Failed);
    }
  }, [globalApiClient, setStatus]);
  return {
    createSubscription
  };
};
exports.useCreateNewsletterSubscription = useCreateNewsletterSubscription;
